import { render } from "./EnrolmentRequests.vue?vue&type=template&id=627ed9be"
import script from "./EnrolmentRequests.vue?vue&type=script&lang=ts"
export * from "./EnrolmentRequests.vue?vue&type=script&lang=ts"
script.render = render

export default script